import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, inject, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { Observable, fromEvent, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { AssistBotService } from '../assist-bot.service';
import { AlertPopup } from 'app/app.config';
import { DOCUMENT } from '@angular/common';


declare const google: any;

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent {
  @ViewChild('autoCompleteInput', { static: false }) autoCompleteInput: ElementRef;
  @Input() suggestionList: any = [];
  @Output() setautoComplete = new EventEmitter<{ data: string, action: string, tags?: string[], questionArray?: string[] }>();
  @Input() autoSearchDafaultValue:string[] = [];
  @Input() defaultSelectLanguage;
  @Input() botType;
  @Input() suggestionEnable;

  singleTag:string
  showSearches: boolean = false;
  isSearching: boolean = false;
  searchedList: any = [];
  selectedTags: string[] = [];
  //placeholderText:string = "ask federal/state laws and your employer policy question";
  @Input() placeholderText;
  constructor(private renderer: Renderer2, private alert: AlertPopup,private assistBotService: AssistBotService,private cdr: ChangeDetectorRef,@Inject(DOCUMENT) private document: Document) {
    this.searchedList = this.suggestionList;

    this.renderer.listen('window', 'click', (e: any) => {
      /**
       * only run when togglebutton is not clicked
       * if we don't check this, all clicks (even on the toggle button) gets into this
       * section which in the result we might never see the menu open!
       * and the menu itself is checked here, and it's where we check just outside of
       * the menu and button the condition abbove must close the menu
       */
      if (e.target !== this.autoCompleteInput.nativeElement) {
        this.showSearches = false;
      }
    });
  }



  ngOnInit() {
 
    this.showSearches = false;
    setTimeout(() => {
      this.Search();
    }, 2000);

    this.assistBotService.searchListBheaviour.subscribe((result: any) => {
      // console.log("result",result);

      if (result.length > 0) {
        this.searchedList = result;
        this.showSearches = true;
      }
      else {
        this.showSearches = true;
        this.isSearching = false;
      }
    });

     

  }

 ngAfterViewInit(){
   
  console.log("this.placeholderText",this.assistBotService.queryType['library']);
  setTimeout(()=>{
    this.autoCompleteInput.nativeElement.focus();},2000);
 }
  ngAfterViewChecked() {
   // this.placeholderText = "Ask federal/state laws and your employer policy question";
    // if (this.defaultSelectLanguage === "hindi") {
    //   this.placeholderText = "प्रश्न पूछो";
    // } else if (this.defaultSelectLanguage === "spanish") {
    //   this.placeholderText = "pregunta";
    // } else {
    //   this.placeholderText = "Ask federal/state laws and your employer policy question";
    // }
  //   if(this.assistBotService.queryType['library']){
  //   this.placeholderText = "ask federal/state laws and your employer policy question";
  // }else{
  //   this.placeholderText = "How may i assist you";
  // }
  this.cdr.detectChanges();
  }

  getList(name): Observable<any> {
    return of(this.filterList(name))
  }

  filterList(name) {

    return this.suggestionList.filter((val: any) => val['question'].trim().toLowerCase().includes(name.trim().toLowerCase())).map((data: any) => data['question']);
  }

  Search() {

    const search$ = fromEvent(this.autoCompleteInput.nativeElement, 'keyup').pipe(
      // map((event: any) => this.autoSearchDafaultValue = event.target.value),
      map((event: any) => this.singleTag = event.target.value),
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.isSearching = true),
      switchMap((term) => term ? this.getList(term) : of<any>(this.suggestionList)),
      tap(() => {
        this.isSearching = false;
        this.showSearches = true;
      }));

    search$.subscribe(data => {
      this.isSearching = false;
      // if (this.autoSearchDafaultValue) {
      if (this.singleTag) {
        this.searchedList = data;
      } else {
        this.searchedList = data.map((data: any) => data['question']);
      }
    });
  }
  
  setSelected(data: string) {
    // Add to selected tags if not already present
    if (data && !this.selectedTags.includes(data)) {
      this.selectedTags.push(data);
    }
    this.searchedList = this.filterList(data);
    this.setautoComplete.emit({ 'data': data, 'action': 'select', 'tags': this.selectedTags });
    this.autoCompleteInput.nativeElement.value = '';
    this.singleTag = '';
    // this.autoSearchDafaultValue = '';
    this.showSearches = false;
    // Keep focus on input for creating next tag
    setTimeout(() => {
      if (this.autoCompleteInput && this.autoCompleteInput.nativeElement) {
        this.autoCompleteInput.nativeElement.focus();
      }
    }, 0);
  }

  removeTag(tag: string) {
    const index = this.selectedTags.indexOf(tag);
    if (index > -1) {
      this.selectedTags.splice(index, 1);
      this.setautoComplete.emit({ 'data': tag, 'action': 'remove', 'tags': this.selectedTags });
    }
  }

  trackById(index: any, item: any): void {
    return item._id;
  }

  closeDropDown(): void {
    this.showSearches = false;
  }

  onEnterKeyDown(event: KeyboardEvent) {
    // Prevent default Enter behavior (newline in textarea)
    event.preventDefault();
    
    // const trimmedValue = this.autoSearchDafaultValue?.trim();
    const trimmedValue = this.singleTag?.trim();
    console.log(trimmedValue, 'trimmedValue');
    
    // Add full content as a single tag (don't split by comma)
    // Each Enter press creates a new tag, all tags form the questionArray
    if (trimmedValue && trimmedValue.length > 0) {
      // Add full content as tag if not already present
      if (!this.selectedTags.includes(trimmedValue)) {
        this.selectedTags.push(trimmedValue);
      }
      
      // questionArray is the array of all selectedTags (each tag is a full sentence)
      const questionArray = [...this.selectedTags];
      console.log('questionArray from selectedTags:', questionArray);
      
      // Emit with the array of all tags
      console.log('Emitting questionArray from autocomplete:', questionArray);
      this.setautoComplete.emit({ 
        'data': trimmedValue, 
        'action': 'TagCreated', 
        'tags': this.selectedTags,
        'questionArray': questionArray
      });
    }
    
    // Clear the input field after Enter key press
    // this.autoSearchDafaultValue = '';
    this.singleTag = '';
    if (this.autoCompleteInput && this.autoCompleteInput.nativeElement) {
      this.autoCompleteInput.nativeElement.value = '';
    }
    
    // Force change detection to update ngModel
    this.cdr.detectChanges();
    
    // Keep focus on input for creating next tag
    setTimeout(() => {
      if (this.autoCompleteInput && this.autoCompleteInput.nativeElement) {
        this.autoCompleteInput.nativeElement.focus();
      }
    }, 0);
    
    this.showSearches = false;
  }

  onKeypressEvent(event: any) {
    if(this.assistBotService.queryType['library']){
    //  if(this.assistBotService.seletedClass.length==0){
    //   // this.alert.showAlertMessage({ "message": "Please select the document from dropdown" });
    //    this.document.getElementById('classdropdown').parentElement.classList.add("inactive");
    //    //return;
    //    if(this.autoSearchDafaultValue.length < 2 && this.autoSearchDafaultValue.length > 0){
    //     this.alert.showAlertMessage({ "message": "Please select the document from dropdown" });
    //     return;
    //    }
    //  }

    }
    
    // this.autoSearchDafaultValue = event.target.value;
    this.singleTag = event.target.value;
    console.log(this.singleTag);
    
    // this.setautoComplete.emit({ 'data': this.autoSearchDafaultValue, 'action': 'Keypress' });
    this.setautoComplete.emit({ 'data': this.singleTag, 'action': 'Keypress', 'tags': this.selectedTags });
  }

  clear() {
    // this.autoSearchDafaultValue = "";
    this.singleTag = "";
    this.selectedTags = [];
    // this.setautoComplete.emit({ 'data': this.autoSearchDafaultValue, 'action': 'Keypress' });
    this.setautoComplete.emit({ 'data': this.singleTag, 'action': 'Keypress', 'tags': this.selectedTags });
  }

}